import { CreateResponsiveStyle, DEVICE_SIZES, minSize, maxSize } from 'rn-responsive-styles'


const useStyles = CreateResponsiveStyle({
        Header_container: {
                shadowColor: '#25243b1a',
                shadowOffset: {width: 0, height: 4},
                shadowOpacity: 0.7,
                shadowRadius: 0.8,
                zIndex: 1
        },

        Header_row1: {
                height: 55,

                backgroundImage: 'linear-gradient(131.93deg, #353535 0%, #000000 100%)',

                flexDirection: 'row',
                alignItems: 'center',
                zIndex: 999
        },

        Header_IDFCLogo: {
                width: 98.17,
                height: 36,
                marginRight: 30,
                marginLeft: 24,
        },

        Header_slider: {
                backgroundColor: '#000000',

                height: 30,

                flexDirection: 'row',
                alignItems: 'center',

                borderRadius: 24,
        },

        Header_sliderOption: {
                paddingHorizontal: 15,
                borderRadius: 24,
                height: '100%',
                justifyContent: 'center',
        },

        Header_sliderOptionText: {
                fontSize: 14,
                color: '#fff',
        },

        Header_sliderOptionActive: {
                backgroundImage: 'linear-gradient(135deg, #9D1D27 0.12%, #6E0A0F 100%)'
        },

        Header_row1col1: {
                flexDirection: 'row',
                alignItems: 'center',
        },

        Header_row1col2: {
                flexDirection: 'row',
                flexGrow: 1,
                alignItems: 'center',
                justifyContent: 'flex-end',
                marginLeft: 30,
                height: '100%',
                zIndex: 999,
        },

        Header_dropdownContainer: {
                height: '100%',
                justifyContent: 'center',
                zIndex: 999,
        },

        Header_row1Dropdown: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',

                paddingHorizontal: 10,

                height: '100%',
        },

        Header_row1DropdownLabel: { marginRight: 5}, Header_row2DropdownLabel: { marginRight: 5 },

        Header_row1DropdownLabelText: {
                color: '#fff',
                fontSize: 14,
        },

        Header_row2DropdownLabelText: {
                color: '#9D1D27',
                fontSize: 14
        },

        Header_row1DropdownArrow: {
                height: 8,
                width: 13
        },

        Header_row1DropdownBodyItemImage: {
                height: 10,
                width: 20
        },

        Header_row2DropdownBodyItemImage: {
                height: 8,
                width: 13
        },

        Header_row1DropdownBody: {
                position: 'absolute',
                top: 55,
                width: 250,
                zIndex: 999,
                flexDirection: 'column',
                borderBottomLeftRadius: 12,
                borderBottomRightRadius: 12,
                paddingBottom: 12,
                backgroundColor: '#000'
        },

        Header_row2DropdownBody: {
                position: 'absolute',
                top: 45,
                width: 460,
                zIndex: 999,
                flexDirection: 'row',
                backgroundColor: '#fff',
                flexWrap: 'wrap',
                padding: 10,
                shadowColor: "rgba(0, 0, 0, 0.13)",
                shadowOffset: {
                        width: 0,
                        height: 0.4,
                },
                shadowRadius: 9,
                shadowOpacity: 1,
        },

        Header_row2DropdownBodyHeading: {
                width: '100%',
                paddingHorizontal: 10,
                paddingVertical: 5,
                flexDirection: 'row',
                justifyContent: 'space-between'
        },

        Header_row2DropdownBodyHeadingTitle: {
                fontSize: 11,
                color: '#42413c'
        },

        Header_row2DropdownBodyHeadingLinkContainer: {
                flexDirection: 'row',
                alignItems: 'center'
        },

        Header_row2DropdownBodyHeadingLink: {
                fontSize: 11,
                fontWeight: 'bold',
                color: '#9c1d28',
                marginRight: 5
        },

        Header_row1DropdownBodyItem: {
                width: '100%',
                paddingVertical: 10,
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundColor: '#000',
                borderTopWidth: 1,
                borderTopColor: "#42413c"
        },

        Header_row2DropdownBodyItem: {
                width: 200,
                paddingVertical: 10,
                flexDirection: 'row',
                justifyContent: 'space-between',
                backgroundImage: 'linear-gradient(131.93deg, #feede8 0%, #fbf1dd 100%)',
                borderRadius: 6,
                margin: 10,
                paddingRight: 10,
                alignItems: 'center'
        },

        Header_row1DropdownBodyItemTextContainer: {
                width: 190,
                paddingHorizontal: 10,
        },

        Header_row2DropdownBodyItemTextContainer: {
                width: 150,
                paddingHorizontal: 10,
        },

        Header_row1DropdownBodyItemText: {
                color: '#FFFFFF'
        },

        Header_row1DropdownBodyItemImageContainer: {
                height: '100%',
                paddingHorizontal: 10,
                width: 40,
                height: 20,
                alignItems: 'center',
                justifyContent: 'center',
        },

        Header_row2DropdownBodyItemImageContainer: {
                height: '100%',
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: '#fff',
                alignItems: 'center',
                justifyContent: 'center',
                transform: 'rotate(-90deg)'
        },

        Header_loginButton: {
                backgroundColor: '#9D1D27',
                color: '#fff',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 25,
                height: 36,
                width: 64,
                flexGrow: 1,
                maxWidth: 80,
                marginRight: 30,
                marginLeft: 10
        },

        Header_loginButtonText: {
                color: '#fff',
        },

        Header_row2: {
                height: 45,

                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-around',
                backgroundColor: "#FFFFFF"
        },

        Header_row2col1: {
                flexDirection: 'row',
                height: '100%'
        },

        Header_row2col2: {
                flexDirection: 'row',
                alignItems: 'center'
        },

        Header_row2Dropdown: {
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',

                marginRight: 20
        },

        Header_row2DropdownLabelText: {
                color: '#9D1D27',
                fontSize: 14,
        },

        Header_row2Phoneicon: {
                height: 35,
                width: 32,
                marginRight: 5
        },

        Header_row2Phonelabel: {
                alignItems: 'center'
        },

        Header_row2PhonelabelLine1: {
                fontSize: 9,
        },

        Header_row2PhonelabelLine2: {
                fontSize: 16,
                color: '#9D1D27',
                fontWeight: 'bold',
        },

        Header_bellIcon: {
                width: 21,
                height: 26,
                marginHorizontal: 20
        },
        spinner:{
                position:'absolute',
                right:20,
                zIndex:999,
                width:100,
                height:30,
                backgroundColor:'transparent'
        }
},

{
        [maxSize(DEVICE_SIZES.MD)]: {
                Header_container: { display: 'none' }
        },

        [maxSize(DEVICE_SIZES.LG)]: {
                Header_IDFCLogo: { marginLeft: 5, marginRight: 20 },
                Header_sliderOption: { paddingHorizontal: 12, borderRadius: 15},
                Header_row1col2: { marginLeft: 15 },
                Header_row1Dropdown: { marginRight: 10 },
                Header_row1DropdownLabel: { marginRight: 5},
                Header_loginButton: { marginRight: 10 }
        }
})

export default useStyles;